import { EventRecording } from "callable-data-objects";
import AudioPlayer from "Components/Shared/AudioPlayer";
import { useEventGroup } from "Hooks/Endpoints";
import React, { useEffect, useState } from "react";
import { Grid, Table, Segment } from "semantic-ui-react";
import moment from "moment";
import useCheckRole from "Hooks/APICheckRole";

const EventRecordings = () => {
  const { hasRole, roles } = useCheckRole();
  const { getRecordings, recordings, event } = useEventGroup();
 
  useEffect(() => {
    if (event) {
      getRecordings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);
  return (
    <div>
      {recordings.map((rec: EventRecording) => (
        <Grid padded stackable>
          <Grid.Column width={4}>
            <Segment color='green'>
              <Table size='small' stackable basic style={{ border: "none" }}>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>Call SID</Table.Cell>
                    <Table.Cell>{rec.cid}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Created</Table.Cell>
                    <Table.Cell>{moment(rec.created).format("YYYY-MM-DD HH:mm:ss")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Retention</Table.Cell>
                    <Table.Cell>{rec.retention}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Expires</Table.Cell>
                    <Table.Cell>{moment(rec.expires).format("YYYY-MM-DD HH:mm:ss")}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>Duration</Table.Cell>
                    <Table.Cell>{rec.duration}s</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>From</Table.Cell>
                    <Table.Cell>{rec.from}</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>To</Table.Cell>
                    <Table.Cell>{rec.to}</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Segment>
          </Grid.Column>
          <Grid.Column width={12}>
            <AudioPlayer
              key={rec.cid}
              src={rec.url}
              duration={parseInt(rec.duration)}
              disablePlay={!hasRole(roles.account.events.recording.roles.play)}
              disableDownload={
                !hasRole(roles.account.events.recording.roles.play)
              }
            />
          </Grid.Column>
        </Grid>
      ))}
    </div>
  );
};

export default EventRecordings;
